// Cartella Magic Team Academy: tenant fisso, non dipende da env di altre PWA.
const isMagicTeam = true;

export const IS_MAGIC_TEAM = isMagicTeam;
export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Magic Team Academy';
export const APP_SHORT_NAME = process.env.REACT_APP_APP_SHORT_NAME || 'MagicTeam';
export const APP_TITLE_PREFIX = process.env.REACT_APP_APP_TITLE_PREFIX || 'Magic Team';
export const APP_TITLE_SUFFIX = process.env.REACT_APP_APP_TITLE_SUFFIX || 'Academy';
export const APP_TAGLINE = process.env.REACT_APP_APP_TAGLINE || 'Formazione · Community · Crescita';
export const BRAND_ACCENT = process.env.REACT_APP_BRAND_ACCENT || '#8E6FA8';
